import { render, staticRenderFns } from "./member_detail.vue?vue&type=template&id=4060e403&scoped=true"
import script from "./member_detail.vue?vue&type=script&lang=ts"
export * from "./member_detail.vue?vue&type=script&lang=ts"
import style0 from "./member_detail.vue?vue&type=style&index=0&id=4060e403&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4060e403",
  null
  
)

export default component.exports